import React from 'react';
type OrnamentProps = {
  className?: string;
  align?: 'center' | 'left';
};
export function Ornament({
  className = '',
  align = 'center'
}: OrnamentProps) {
  return <div className={`flex items-center gap-2 ${align === 'center' ? 'justify-center' : 'justify-start'} ${className}`} aria-hidden="true" data-id="element-186" data-mp="gubytfy06e8y">
      <span className="h-px w-10 bg-gold/70" data-id="element-187" data-mp="71enbtrfhpju" />
      <span className="h-1.5 w-1.5 rotate-45 bg-gold" data-id="element-188" data-mp="30kx2tqijyns" />
      <span className="h-px w-10 bg-gold/70" data-id="element-189" data-mp="325t6nsh7pnr" />
    </div>;
}